import { useHistory, useLocation, Redirect, Route, Switch } from 'react-router-dom'

import { Auth, AuthModalHash } from '@scouts/auth'
import { CustomerChrome as Chrome } from '@scouts/ui'

import { PATH_WELCOME } from '@/constants'

import { useIntercomLoader } from '@/hooks/use-intercom-loader'

import { WelcomeStart } from './WelcomeStart'

export const WelcomeContainer = () => {
    useIntercomLoader()
    const history = useHistory()
    const { hash } = useLocation()

    const closeAuthModal = () => {
        history.push({ hash: undefined })
    }

    const isAuthModalOpen =
        hash === `#${AuthModalHash.forgot}` || hash === `#${AuthModalHash.login}` || hash === `#${AuthModalHash.signup}`

    return (
        <Chrome>
            <Chrome.Header>
                <Chrome.HeaderGroup>
                    <Chrome.Logo />
                </Chrome.HeaderGroup>
            </Chrome.Header>
            <Switch>
                <Route path={PATH_WELCOME} exact component={WelcomeStart} />

                <Redirect to={PATH_WELCOME} />
            </Switch>

            {isAuthModalOpen && <Auth.Modal onClose={closeAuthModal} />}
        </Chrome>
    )
}

export default WelcomeContainer
